import { EventEmitter, Injectable } from '@angular/core';  
import { Event, NavigationEnd, Router } from '@angular/router';  
import { MatDialog, MatDialogRef } from '@angular/material/dialog';  
import { SpinnerComponent } from './spinner.component';  

@Injectable() 
export class SpinnerService {

  constructor(private dialog: MatDialog) { }

  start(): MatDialogRef<SpinnerComponent> {  
        
    const dialogRef = this.dialog.open(SpinnerComponent,{  
        disableClose: true  
    });  
    return dialogRef;  
  };  

stop(ref:MatDialogRef<SpinnerComponent>){  
    ref.close();  
}   
}
